import React, {useRef, useState} from 'react';
import useOnClickOutside from 'utilities/hooks/useOutsideClick';

interface DropDownProps {
  id: string;
  options: Array<TOption>;
  listWrapperClassName: string;
}
const DropDown = ({id, options, listWrapperClassName}: DropDownProps) => {
  const wrapperRef = useRef(null);
  const [isOpen, setisOpen] = useState<boolean>(false);

  useOnClickOutside(wrapperRef, () => setisOpen(false));
  return (
    <div className={`relative`} ref={wrapperRef}>
      <button
        onClick={() => setisOpen(!isOpen)}
        className={`icon-menu-chat text-[18px]  font-medium`}
      />
      {isOpen && (
        <div
          className={`${listWrapperClassName} left-4  rounded-[8px]   bg-white shadow-[4px_4px_25px__rgba(0,0,0,0.1)] p-2`}
        >
          {options.map((item, index) => {
            return (
              <button
                key={index}
                onClick={() => {
                  item.action(id);
                  setisOpen(false);
                }}
                className={`flex col-start-1 col-end-2 p-2 gap-4 justify-center items-center `}
              >
                <div className="text-gray-5">{item.icon}</div>
                <span className="text-gray-6 text-[16px]  font-medium">
                  {item.title}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DropDown;
